
/* User defined enums/constants */
import { MetricType } from '../../enums/scheduling.enum';

export class MetricRequest {
  booking: any;
  appointmentStatus?: string;
  metricList: MetricData[];

  constructor(
    metricList: MetricData[],
    bookingId: string,
    appointmentStatus?: any
  ) {
    this.booking = { 'Id': !!bookingId ? bookingId : '' };
    this.metricList = metricList;
    this.appointmentStatus = appointmentStatus;
  }

  static convertMetricDetailsToRequest(metricDetails: MetricDetails, bookingId?: string, appointmentStatus?: any): MetricRequest {
    let metricList: MetricData[] = [];

    if (!!metricDetails.searched) {
      metricList.push(metricDetails.searched);
    }
    if (!!metricDetails.bestSite) {
      metricList.push(metricDetails.bestSite);
    }
    if (!!metricDetails.selected) {
      metricList.push(metricDetails.selected);
    }
    if (!!metricDetails.bestDate) {
      metricList.push(metricDetails.bestDate);
    }

    return new MetricRequest(metricList, bookingId, appointmentStatus);
  }
}

export class MetricDetails {
  searched?: MetricData;
  bestSite?: MetricData;
  selected?: MetricData;
  bestDate?: MetricData;
  examId?: string;

  constructor(
    searched?: MetricData,
    bestSite?: MetricData,
    selected?: MetricData,
    bestDate?: MetricData,
    examId?: string
  ) {
    this.searched = searched;
    this.bestSite = bestSite;
    this.selected = selected;
    this.bestDate = bestDate;
    this.examId = examId;
  }

}

export class MetricData {
  type: MetricType;
  date?: any;
  data: any;

  constructor(
    type: MetricType,
    data: any,
    date?: any
  ) {
    this.data = data;
    this.date = date;
    this.type = type;
  }
}


